var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"single-block-container"},[(!_vm.token)?_c('RequestPasswordResetForm'):_c('PasswordResetForm',{attrs:{"token":_vm.token}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }